module.exports = __webpack_public_path__ + "static/media/folding_boxes.415f628f.jpg";